class PageLoadAnimation {
	constructor(isForm = true) {
		if(isForm) {
			this._init()
		} else {
			this.promiseInit()
		}
	}
	_init() {
		this.setElAction()
		if(!this.elAction) {
			return
		}

		this.toggleLoading(false)

		this.els = document.querySelectorAll('[data-form-animated]')
		if(this.els.length == 0) {
			return
		}

		this.els.forEach(el => {
			el.addEventListener('submit', () => this.onSubmit())
		});
	}
	promiseInit() {
		if(this.elAction) {
			return true
		}

		this.setElAction()


		if(!this.elAction) {
			return false
		}

		this.toggleLoading(false)
		return true
	}
	onSubmit() {
		// this.toggleLoading(true)
		// Add possible timeout to cancel?
	}
	toggleLoading(on) {
		if(!this.elAction) {
			return
		}
		if(on) {
			this.elAction.classList.add('lds-spinner--active')
			this.elBody.style.overflow = 'hidden'
		}
		else {
			this.elAction.classList.remove('lds-spinner--active')
			this.elBody.style.overflow = 'auto'
		}
	}
	setElAction() {
		this.elAction = document.querySelector('[data-form-animated-action]')

		if(!this.elAction) {
			return
		}

		this.elBody = document.querySelector('[data-body]')
	}
}

export default PageLoadAnimation